import React, {useState} from 'react'
import { detalle_blog } from '../../../assets/data/detalle_blog_header'
import './header.css'
import { Tooltip } from 'react-tooltip'
import { useTranslation } from 'react-i18next';
import {Helmet} from "react-helmet";

const Header = ({ titulo, categorias, urlImagen, fecha, resumen }) => {
  const blogTitulo = titulo;
  const str = titulo;
  let parts;
  try {
    parts = str.split(" ");
  } catch (error) {
      // Manejar el error aquí, por ejemplo, puedes establecer parts como un array vacío
      console.error("No se pudo hacer el split:", error);
      parts = [];
  }
  let firstPart, secondPart;
  const [t, i18n] = useTranslation("detail_blog");

  const [activeImage, setActiveImagen] = useState(null);

  const handleImageClick = (index) => {
      setActiveImagen(index === activeImage ? null : index);
  };

  const cambioDesc = () => {
    var existingDescription = document.querySelector('meta[name="description"]');
    var newDescription = {resumen};
    
    if (existingDescription) {
      existingDescription.setAttribute('content', newDescription);
    }

  }

  const formatDate = (date) => {
    const options = { day: "numeric", month: "long", year: "numeric" };

    // return new Date(date).toLocaleDateString(undefined, options);
    return new Date(date).toLocaleDateString(i18n.language, options);
};
  
  if (parts.length > 2) {
    firstPart = parts[0] + " " + parts[1];
    secondPart = parts.slice(2).join(" ");
    
  } else {
    firstPart = parts[0] + " ";
    secondPart = parts[1];
  }

  return (
    <div className="DB_header">
      {/*<Helmet>
         <meta charset="utf-8" />
          <title>{titulo}</title>
          <meta property="og:title" content={titulo} />
          <meta name="description" content={resumen} />
          <meta property="og:description" content={resumen} />
          <meta property="og:image" content={urlImagen} />
        </Helmet>*/}
      <div className="blog_titulo" id='blog_titulo' style={{ backgroundImage: `url('${ urlImagen}')`  }}>
        <h3>
          {firstPart} <span className="txt_naranja">{secondPart}</span>
        </h3>
        {/* <p className='tit_fecha'>{formatDate(fecha)}</p>*/}
      </div>
      <div className="blog_fecha_d">
        <p className='tit_fecha_mov'>{formatDate(fecha)}</p>
      </div>
      <div className="blog_categorias">
        
        {
          categorias.length > 0 && categorias.map((categoria) => {
            const { nombre, tagCategory, poster } = !!categoria && categoria;
            return(
              <img key={ tagCategory } 
              className={ `categoria_1 ${categoria.tagCategory}${activeImage === 1 ? 'active' : ''}` } 
              src={require(`../../../assets/img/${categoria.tagCategory}.svg`)}
              data-tooltip-id="tooltip-section1" 
                                        data-tooltip-content={categoria?.nombre ?? ""}
                                        data-tooltip-place="top"
              />
              
            )
          })
          
        }
         <Tooltip 
                                    id="tooltip-section1" 
                                    className='customTooltip'
                                    arrowColor='transparent'
                                />

        {/* <img className="categoria_1" src={'../../..'+detalle_blog[0].categorias[0].poster}/>
        <img className="categoria_2" src={'../../..'+detalle_blog[0].categorias[1].poster}/>  */}
      </div>
        
    </div>
    
  )
}

export default Header
